import { LedgerBridge } from '@/services/LedgerBridge';

(async () => {
  new LedgerBridge();
})();
